// TanStack Query key factory for the Skill Registry entity — same shape as
// entities/agent/model/queryKeys.ts.

export const skillKeys = {
  list: () => ['skill', 'list'] as const,
  detail: (skillId: string) => ['skill', 'detail', skillId] as const,
  versions: (skillId: string) => ['skill', 'versions', skillId] as const,
  agentList: (agentId: string) => ['skill', 'agent-list', agentId] as const,
  agentVersions: (agentId: string, skillId: string) =>
    ['skill', 'agent-versions', agentId, skillId] as const,
};
